import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import Faq from './modules/faq'

Vue.use(Vuex)

const store = new Store({
  modules: {
    Faq,
  },
  strict: process.env.NODE_ENV !== 'production'
})

export default store
